import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-tpa-get-evidence-export-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class TpaGetEvidenceExportApiManualComponent extends ApiSpecComponent {
    initSpecs(): ApiSpecificationModel {
        return <ApiSpecificationModel>{
            name: this.translation.t("tableOfContents.externalConnectionsGetEvidenceDocument"),
            description: this.translation.t("specs.externalConnectionsGetEvidenceDocumentDescription"),
            httpMethod: "GET",
            path: "thirdpartyassurance/getevidencedocument/{requestId}",

            parameters: [
                {
                    name: "requestId",
                    description: this.translation.t("parameters.externalConnectionsRequestIdDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "controlidentifier",
                    description: this.translation.t("parameters.externalConnectionsControlidentifierDescription"),
                    in: "query",
                    paramType: "integer",
                    required: true,
                    example: "1",
                },
                {
                    name: "documentid",
                    description: this.translation.t("parameters.externalConnectionsDocumentIdDescription"),
                    in: "query",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "binary data",
                },
            ],
        };
    }
}
